module.exports = fox._r("images/thanksgiving/gift-152.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/thanksgiving/gift-152.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/thanksgiving/gift-152.png
// module id = 376
// module chunks = 4